import { IconButton } from '@fluentui/react';
import React, { Component } from 'react';
import { Fragment } from 'react';
import { DataTVATaux } from '../../data/DataTVATaux';
import { EUIComboBox } from '../EUI/EUIComboBox';

export class ComboBoxTVATaux extends Component {

    static defaultProps = {
        idOperation: undefined,
        idProduit: undefined,
        idSousProduit: undefined,
        label: "TVA",
        onClickDown: undefined,
        onClickUp: undefined,
        placeholder: "TVA",
        selectedKey: []
    };

    _onClickDown = (item) => () => {
        const { onClickDown, selectedKey } = this.props;

        let newSelectedKey = [...selectedKey];
        const clicked = newSelectedKey.find(tva => tva.idTVACas === item.idTVACas);
        if (!!clicked) {
            const below = newSelectedKey.find(tva => tva.ordre === clicked.ordre + 1);
            clicked.ordre++;
            if (!!below) {
                below.ordre--;
            }
            if (!!onClickDown && typeof onClickDown === "function")
                onClickDown(newSelectedKey);
        }
    };

    _onClickUp = (item) => () => {
        const { onClickUp, selectedKey } = this.props;

        let newSelectedKey = [...selectedKey];
        const clicked = selectedKey.find(tva => tva.idTVACas === item.idTVACas);
        if (!!clicked) {
            const above = selectedKey.find(tva => tva.ordre === clicked.ordre - 1);
            clicked.ordre--;
            if (!!above) {
                above.ordre++;
            }
            if (!!onClickUp && typeof onClickUp === "function")
                onClickUp(newSelectedKey);
        }
    };

    _onRenderOption = (props, defaultRender) => {

        const { selectedKey } = this.props;
        const option = defaultRender(props);

        let disabledUp = true;
        let disabledDown = true;

        const item = selectedKey.find(key => key.idTVACas === props.key);
        if (!!item) {
            const minOrdre = Math.min(...selectedKey.map(key => key.ordre));
            const maxOrdre = Math.max(...selectedKey.map(key => key.ordre));
            disabledUp = item.ordre === minOrdre;
            disabledDown = item.ordre === maxOrdre;
        }

        const styles = { rootDisabled: { backgroundColor: "unset!important" } };
        return <Fragment>
            <IconButton
                disabled={disabledUp}
                iconProps={{ iconName: "CaretSolidUp" }}
                onClick={this._onClickUp(item)}
                styles={styles}
            />
            <IconButton
                disabled={disabledDown}
                iconProps={{ iconName: "CaretSolidDown" }}
                onClick={this._onClickDown(item)}
                styles={styles}
            />
            {option}
        </Fragment>;

    };

    render = () => {

        const { idOperation, idProduit, idSousProduit, selectedKey } = this.props;

        let fetchMethod = null;
        if (!!idOperation) {
            const filtres = { idOperation };
            fetchMethod = () => DataTVATaux._chargementListTVATaux(filtres);
        }
        else if (!!idProduit && !!idSousProduit) {
            const filtres = { idProduit, idSousProduit };
            fetchMethod = () => DataTVATaux._chargementListTVATaux(filtres);
        }

        return <EUIComboBox
            {...this.props}
            fetchMethod={fetchMethod}
            itemKey={item => item.idTVACas}
            itemText={item => item.tvaCas}
            onRenderOption={this._onRenderOption}
            selectedKey={selectedKey.sort((a, b) => a.ordre - b.ordre).map(tvaTaux => tvaTaux.idTVACas)}
            selectedKeysOnTop
            stamp={[idOperation, idProduit, idSousProduit]}
        />;

    };

};